<div class="errorMsgContainer">
  <h2>Application is offline</h2>
  <p>The FSCD application is currently offline for maintenance. We apologize for the inconvenience.</p>
</div>
